import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import DisplayPlatform from '../views/DisplayPlatform.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/DisplayPlatform',
    name: 'DisplayPlatform',
    component: DisplayPlatform
  }
]

const router = new VueRouter({
  routes
})

export default router
